import axios from 'axios';
import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import Swal from "sweetalert2";
// import i18n from "@/plugins/i18n";
import appV from '@/version.json'
const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axios.defaults.headers.post['baseURL'] = process.env.VUE_APP_POST_API_URL;

http.interceptors.request.use(
  config => {

    config.headers.common['App-Version'] = appV.versionCode; 

    const accessToken = store.getters['auth/token'];
    if (accessToken) {
      config.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }
    const lang = store.getters['lang/locale'];
    config.baseURL = process.env.VUE_APP_API_URL + `${lang}/api/`;
    return config;
  },
  error => Promise.reject(error),
);


http.interceptors.response.use(response => {
  return response;
}, function (error) {
  const originalRequest = error.config;
  const errorCode = error.response.status;
  console.log('error.response.data.message',error.response.data.message);
  var title = '';
  var message = '';

  if (errorCode === 401) {
    title = `Unauthorized`
    message = error.response.data.message;
    store.dispatch('auth/clearUser');
    router.push({ name: 'login' })

  } else if (errorCode === 500) {
    title = 'Internal Server Error';
    message =
      'There is an error on our server, please contact admin or try again later!';
  } else if (errorCode === 400) {
    // title = i18n.t('Bad_Request')
    message = error.response.data.message;
  } else if (errorCode === 404) {
    // title = i18n.t('Not_Found')
    message = error.response.data.message;
  }

  else if (errorCode === 406) {
    // title = i18n.t('Not_Found')
    message = error.response.data.message;

    Swal.fire({
      title: message,
      showDenyButton: true,
      confirmButtonColor: true,
      confirmButtonText: 'Refresh',
    }).then((result) => {
      location.reload();
    })
    return Promise.reject(error);
  }

  else if (errorCode === 422 ) {
    console.log('error.response.data.message',error.response.data.message);
    message = error.response.data.message;

    if(error.response.data.product)
      error.response.data.product.items.forEach(item => {
          message += '<br>' + item.title 
      }); 
  }
  Vue.notify({
    group: 'notification',
    title: title,
    type: 'error',
    speed: 1000,
    text: message,
  });
  return Promise.reject(error);
});

const HttpPlugin = {
  install(V, options) {
    V.prototype.$http = http;
  },
};


Vue.use(HttpPlugin);


export default http;
